<template>
    <div class="small-font-size-label" @contextmenu.prevent>
        <v-row class="mb-3">
            <v-col>
                <v-autocomplete
                    outlined
                    flat
                    dense
                    hide-no-data
                    hide-details
                    :items="itemsFlatArray"
                    :label="filterHint"
                    :item-text="item => getItemTextFromLablesValues(item)"
                    item-value="name"
                    v-model="search"
                    clearable
                    @change="onTreeviewChange()"
                ></v-autocomplete>
            </v-col>
            <v-col cols="auto" class="d-flex flex-column justify-center ps-0 mx-auto">
                <slot name="actions"></slot>
            </v-col>
        </v-row>
        <div id="tree-view-container" class="pt-0" :class="on_mdAndUp ? 'scroll-start' : 'scroll-end'">
        <v-treeview
            id="tree-view"
            :style="{width: on_mdAndUp ? treeWidth + 'px': '100%', minWidth: minTreeWidth + 'px'}"
            ref="tree"
            dense
            hoverable
            activatable
            :items="items"
            :open="activeItems"
            :active="activeItems"
            item-key="id"
            selection-type="independent"
            @update:active="$emit('update:active', itemsFlatArray.find(category => category.id == $event[0])); findTreeWidth();"
            @update:open="$emit('update:open', itemsFlatArray.find(category => category.id == $event[$event.length > 0 ? $event.length - 1 : 0]))"
            class="ms-0 me-auto"
        >
            <template v-slot:label="{item, active}">
                <div
                	type="button"
                	:style="[(item.type === 1 && !active) ? {'color':color}: {}]"
                	@click="$emit('update:open', itemsFlatArray.find(category => category.id == $event[$event.length > 0 ? $event.length - 1 : 0]))"
                    @contextmenu.prevent="initContextMenu($event, item)"
                >{{ `${getItemTextFromLablesValues(item)}` }}</div>
            </template>
            <template v-slot:prepend="{item, open}">
                <v-icon type="button" @click="changePath(item, open)"
                     small color="#d9bd5d" v-if="item.children ? item.children.length > 0 : false">
                    {{open ? 'fa-minus' : 'fa-plus'}}
                </v-icon>
            </template>
        </v-treeview>
        </div>

        <!-- context menu -->
        <v-menu
            v-if="showContextMenu"
            v-model="contextMenuData.show"
            :position-x="contextMenuData.x"
            :position-y="contextMenuData.y"
            absolute
            offset-y
        >
            <v-list>
                <v-list-item
                	v-for="(item, index) in contextmenuItems"
                	:key="index"
                    :disabled="typeof item.disabled === 'function' ? item.disabled(contextMenuData.node) : Boolean(item.disabled)"
                    @click="$emit(`context-menu-${item.event}`, contextMenuData.node)"
                >
                    <v-list-item-title class="text-capitalize">{{ item.title }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
export default {
    name: "BeeTreeView",
    props: {
        items: { type: Array, default: () => []},
        lablesValues: { type: Array, default: () => ['id', 'name']},
        filterHint: { type: String },
        showContextMenu: { type: Boolean },
        contextmenuItems: { type: Array, default: () => []},
    },
    data: () => ({
        itemsFlatArray: [],
        search: null,
        activeItems: [],
        openOnClick:false,
        
        contextMenuData: {
            node: {},
            show: null,
            x: null,
            y: null,
        },

        minTreeWidth: 305,
        treeWidth: 305,
    }),
    methods: {
        getFlatArray(nestedObject) {
            this.itemsFlatArray.push(nestedObject)
            if(nestedObject.children?.length > 0) 
                nestedObject.children.forEach(children => this.getFlatArray(children))
        },
        getPathByItemName(items, path, itemName) {
            items?.some(item => {
				if(item.name == itemName) { 
					this.activeItems = [...path, item.id];
					return true
				}
				else {
					this.getPathByItemName(item.children, [...path, item.id], itemName); 
					return false
				}
			});
        },
        changePath(item, open) {
            if(open) {
                this.activeItems = this.arrayRemove(this.activeItems, item.id)
            } else  this.activeItems = [...this.activeItems, item.id]
        },
        onTreeviewChange(){
            this.getPathByItemName(this.items, [], this.search)
            this.$emit('update:active',this.itemsFlatArray.find(category => category.name == this.activeItems[this.activeItems.length -1]))
        },
        arrayRemove(arr, value) { 
            return arr.filter(function(ele){ 
                return ele != value; 
            });
        },
        getItemTextFromLablesValues(item){
            let fields = '' 
            this.lablesValues.forEach(element => {
            if(this.lablesValues.indexOf(element) < (this.lablesValues.length -1) )
                fields = fields + item[element] + '-' 
            else
                fields = fields + item[element] 
            }); 

            return fields;
        },
        findTreeWidth(){
            if(this.$refs.tree){
                let maxWidth = 0;
                let theMostWidthElement;

                // find the most width tree element
                var nodes = this.$refs.tree.$el.querySelectorAll('.v-treeview-node__root div');
                nodes.forEach(c => {
                    if (c.clientWidth > maxWidth) {
                        theMostWidthElement = c;
                        maxWidth = c.clientWidth;
                    }
                });
                // find the new width
                let newWidth = 
                    theMostWidthElement.clientWidth 
                    + this.$refs.tree.$el.getBoundingClientRect().right
                    - theMostWidthElement.getBoundingClientRect().right
                    // + 32; //32 just for offset

                // set Tree width
                this.treeWidth = newWidth > 305 ? newWidth : 305;
            }
        },

        initContextMenu(e, item) {
            if (this.showContextMenu) {
                this.contextMenuData.x = e.clientX;
                this.contextMenuData.y = e.clientY;

                this.contextMenuData.node = item;
                this.$nextTick(() => {
                    this.contextMenuData.show = true
                })
            }
        }
    },
    computed:{
        color (){
            return this.$vuetify.theme.themes.light.deletingColor;
        },
        localValue: {
            get: function() {
                return this.value
            },
            set: function(value) {
                this.$emit('input', value)
            }
        },
        on_mdAndUp(){
            if(this.$vuetify.breakpoint.mdAndUp)
                return true
            return false;
        }
    },
    mounted() {
        this.findTreeWidth();
        this.items.forEach(nestedObject => this.getFlatArray(nestedObject));
    }
}
</script>
<style lang="scss">
.small-font-size-label .v-text-field .v-label {
    transform-origin: top right;
    font-size: 13px !important;
}
.v-icon.v-icon.v-icon--link {
    outline: none;
    max-inline-size: min-content;
}
.v-treeview-node__toggle {
    display: 0;
    z-index: -1;
}

.scroll-start {
    overflow-y: auto;
    [dir="rtl"] &{
        direction: ltr;
    }
    [dir="ltr"] &{
        direction: rtl;
    }
}
.scroll-end {
    overflow-y: auto;
    [dir="rtl"] &{
        direction: rtl;
    }
    [dir="ltr"] &{
        direction: ltr;
    }
}

#tree-view-container::-webkit-scrollbar {
    height: 10px;
}
#tree-view{
    height: 60vh;
    margin-left: auto;

    [dir="rtl"] &{
        direction: rtl;
    }
    [dir="ltr"] &{
        direction: ltr;
    }
}
</style>